import { Field, Int, ObjectType } from '@nestjs/graphql'

export interface PaginatedResponseType {
  totalRows: number
  items: any[]
}

// @ts-ignore
export default function PaginatedResponse<TItem>(TItemClass: TItem): any {

  @ObjectType({ isAbstract: true })
  abstract class PaginatedResponseClass implements PaginatedResponseType {
    @Field(type => [TItemClass])
    items!: TItem[]

    @Field(type => Int)
    totalRows!: number
  }

  return PaginatedResponseClass
}
